import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: []
    },
    lastName: {
      validations: []
    },
    telNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    theme: {
      validations: []
    },
    eventextra1: {
      validations: []
    },
    plannedguestcount: {
      validations: []
    },
    reference: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:',
            mapping: 'lastName'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number:',
            mapping: 'telNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email Address:',
            mapping: 'email'
      },
      {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:',
            mapping: 'eventDate'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Event Type:',
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Location:',
            mapping: 'eventextra1'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Number of Guests:',
            mapping: 'plannedguestcount'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'How did you hear about us?:',
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Additional Info:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Eating Royally Contact Form',
    formId: '683',
    clientKey: '1C163EEA-F12F-4843-A14E-510BE4BF79F4',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// C:/Users/adrienn.bonnyai/Web-Inquiry/inquiry-renderer/client_forms/eatingroyally/form_structure.js